import { useEffect, useState } from 'react'

import { fabric } from 'fabric'

import NodeRegistry from '../../logic/mana/nodes/NodeRegistry'



export default function GameInit({ children = undefined as any }) {

	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		// init game
		async function init() {

			fabric.Object.prototype.objectCaching = false;
			NodeRegistry.register()

			setMounted(true)
		}

		init()
	}, [])

	return <>
		{mounted && (
			children
		)}
	</>
}
